// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Chat from '../_raw/ui/icon_chat.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Chat);
